import { createAsyncThunk } from '@reduxjs/toolkit'
import { publicAxiosInstance, PrivateAxiosInstance } from '../../../services/createAxiosInstance';
import { handleApiError } from '../../../utils/handleApiError';
import { URLs } from '../../../constants/apiEndpoints';

//add a new session
export const createSession = createAsyncThunk('session/create', async ({ formData }, { rejectWithValue }) => {
    console.log('formdata: ', formData)
    try {

        const res = await PrivateAxiosInstance.post(URLs.CRAETE_SESSION_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', //multipart file
            },
        });
        return res.data;
    } catch (error) {
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage });
    }
})

//edit session
export const editSession = createAsyncThunk('session/edit', async ({ eventId, formData }, { rejectWithValue }) => {
    try {
        const res = await PrivateAxiosInstance.put(URLs.EDIT_SESSION_URL.replace(':eventId', eventId), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res.data;
    } catch (error) {

        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage });
    }
})

// get all sessions - PUBLIC
export const getAllSessions = createAsyncThunk('session/fetchAll', async (_, { rejectWithValue }) => {
    try {
        const res = await publicAxiosInstance.get(URLs.FETCH_ALL_SESSION_URL); ///use pubic
        return res.data;
    } catch (error) {
        const errorMessage = await handleApiError(error);
        return rejectWithValue({ error: errorMessage });
    }
}
);


//getbyid session
export const getSessionById = createAsyncThunk('session/getSessiontById', async ({ eventId }, { rejectWithValue }) => {
    try {
        const res = await PrivateAxiosInstance.get(URLs.GET_SESSION_BY_ID_URL.replace(':eventId', eventId), {
            headers: {
                'Content-Type': 'multipart/form-data',
            },

        });
        return res.data;
    } catch (error) {
        ;
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage });
    }
})

//getbyid session
export const deleteSession = createAsyncThunk('session/delete', async ({ eventId }, { rejectWithValue }) => {
    try {
        const res = await PrivateAxiosInstance.delete(URLs.DELETE_SESSION_BY_ID_URL.replace(':eventId', eventId))
        return res.data;
    } catch (error) {
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage });
    }
})
